import { render, staticRenderFns } from "./PostConsultationEmailDialog.vue?vue&type=template&id=1b8b1156"
import script from "./PostConsultationEmailDialog.vue?vue&type=script&lang=js"
export * from "./PostConsultationEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports